import { useContext } from 'react'
import { UnitContext } from '@/contexts/unitContext'

export const useUnitContext = () => {
	const context = useContext(UnitContext)
	if (!context) {
		throw new Error('useUnit must be used within a UnitProvider')
	}
	return context
}
